export default class TokenService {
  constructor({ host, accountId }) {
    this.host = host
    this.accountId = accountId
  }

  async getToken(visitorId) {
    let url = `${this.host}/chatToken/${this.accountId}/${visitorId}`

    var result = await fetch(url, {
      method: 'GET',
    })
    var token = await result.text()

    return token
  }

  async saveToken(visitorId, token) {
    let url = `${this.host}/chatToken/${this.accountId}/${visitorId}/${token}`

    var result = await fetch(url, {
      method: 'POST',
    })
    return result.status == 200
  }
}
